import isEmpty from 'lodash-es/isEmpty';
import { useEffect, useState } from 'react';
import { checkForActivation } from 'wisestep-api';

import { useWorkspaceContext } from '../context';

const useFeatureValidation = (feature: string | undefined, authorities: string[] | undefined) => {
  const workspaceContext = useWorkspaceContext();

  const [featureAllowed, setFeatureAllowed] = useState<boolean | null>(null);

  useEffect(() => {
    async function validateRoute() {
      const workspaceRoles = workspaceContext.roles;
      const workspaceFeatures = workspaceContext.workspacePlan;

      let checkFeature: boolean | null = null;
      let checkAuthorities: boolean | null = null;
      if (feature) {
        checkFeature = checkForActivation(workspaceFeatures, feature) == true;
      }
      if (authorities && isEmpty(authorities) && workspaceRoles && isEmpty(workspaceRoles)) {
        authorities.forEach((authority: string) => {
          if (workspaceRoles.indexOf(authority) !== -1) {
            checkAuthorities = true;
          } else {
            checkAuthorities = false;
          }
        });
      }

      if (checkFeature !== null && checkAuthorities !== null) {
        setFeatureAllowed(checkFeature && checkAuthorities);
      } else if (checkFeature !== null) {
        setFeatureAllowed(checkFeature);
      } else if (checkAuthorities !== null) {
        setFeatureAllowed(checkAuthorities);
      } else {
        setFeatureAllowed(null);
      }
    }
    validateRoute();
  }, [
    featureAllowed,
    feature,
    authorities,
    workspaceContext.roles,
    workspaceContext.workspacePlan,
  ]);

  return featureAllowed;
};

export default useFeatureValidation;
